import { useCallback, useEffect, useState } from 'react'

import { AppRouter } from '@/app/router'
import { BrandLoadingPage } from '@/components/BrandLoadingPage'
import { useAuthInit } from '@/hooks/useAuthInit'

export const App = () => {
  const { initDone } = useAuthInit()
  const [brandSplashDone, setBrandSplashDone] = useState(false)
  const onBrandSplashComplete = useCallback(() => setBrandSplashDone(true), [])

  // Warm the home chunk during splash so we don't flash a second loader after.
  useEffect(() => {
    void import('@/pages/HomePage')
  }, [])

  if (!initDone || !brandSplashDone) {
    return (
      <BrandLoadingPage
        readyToFinish={initDone}
        onComplete={onBrandSplashComplete}
      />
    )
  }

  // CookieConsentBanner is rendered inside the router (via RootLayout) — it
  // uses <Link>, which needs the React Router context. Mounting it as a
  // sibling of AppRouter would crash with "Cannot destructure 'basename' of
  // useContext(...) as it is null."
  return <AppRouter />
}
